'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * @flow
 */

var API_INITIAL = exports.API_INITIAL = 0;
var API_FETCHING = exports.API_FETCHING = 100;
var API_SUCCESS = exports.API_SUCCESS = 200;
var API_PAGINATION_FINISHED = exports.API_PAGINATION_FINISHED = 300;
var API_FAILED = exports.API_FAILED = 400;
var API_SWIPE_REFRESH = exports.API_SWIPE_REFRESH = 500;
var API_FETCHING_PAGINATION = exports.API_FETCHING_PAGINATION = 600;
var INIT = exports.INIT = 'init';
var LOAD_MORE = exports.LOAD_MORE = 'loadmore';
exports.default = {
  API_INITIAL: API_INITIAL,
  API_FETCHING: API_FETCHING,
  API_SUCCESS: API_SUCCESS,
  API_FAILED: API_FAILED,
  INIT: INIT,
  LOAD_MORE: LOAD_MORE,
  API_PAGINATION_FINISHED: API_PAGINATION_FINISHED,
  API_SWIPE_REFRESH: API_SWIPE_REFRESH,
  API_FETCHING_PAGINATION: API_FETCHING_PAGINATION
};